import axios from 'axios';
import config from '@/config/constants.js';

export default {
    namespaced: true,
    state: {
        status: '',
    },
    mutations: {
        loading(state) {
            state.status = 'loading';
        },
        status(state, status) {
            state.status = status;
        },
        success(state) {
            state.status = '';
        },
    },
    actions: {
        add_users: function ({commit, rootGetters}, users) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve) {
                commit('loading');
                let errorsCounter = 0;
                let phone = '';
                for (let i in users) {
                    let user = users[i];
                    phone = user.phone
                        .replaceAll(' ', '')
                        .replaceAll('-', '');
                    phone = config.phone_extension + phone;
                    let user_to_save = {
                        owner_id: rootGetters['Authenticate/current_user'].phone_number,
                        first_name: user.first_name,
                        last_name: user.last_name,
                        email: user.email,
                        phone_number: phone,
                        is_admin: user.is_admin,
                    };

                    try {
                        await axios.post(config.api_url + 'add_employee', user_to_save);
                        user['error'] = '';
                    } catch (error) {
                        errorsCounter++;
                        user['error'] = error.response.data.message;
                    }
                }
                commit('success');
                resolve(errorsCounter);
            });
        },
    },
};
